import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'female-cortisol-diet',
	landing: {
		ids: ['loader-f-cortisol-diet'],
		route: {
			path: '/cortisol-diet-f',
			name: 'female-cortisol-diet-funnel',
		},
	},
	funnel: {
		id: 'ob-female-cortisol-diet',
		route: {
			path: '/cortisol-diet-f/ob/:page*',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-cortisol-diet-onboarding',
		},
		slug: 'female-cortisol-diet',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-f',
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
